import React, { lazy } from "react";
import PrivateAuth from "./PrivateAuth";
import Properties from "../Views/Main Panel/Properties";
import CreateProperty from "../Views/Main Panel/Properties/CreateProperty";
import BodyTypeDetails from "../Views/Main Panel/Automobiles/BodyType";
import ColourrDetails from "../Views/Main Panel/Automobiles/ColourDetails";
import BannerDetails from "../Views/Main Panel/Banner";
import StateCity from "../Views/Main Panel/StateCity";
import PlotComponent from "../Views/Main Panel/Plots";
import ShowPlot from "../Views/Main Panel/Plots/ShowPlot";
import CreatePlot from "../Views/Main Panel/Plots/CreatePlot";
import Blog from "../Views/Main Panel/Blog";
import AddBlog from "../Views/Main Panel/Blog/AddBlog";
import AddBlogCategory from "../Views/Main Panel/Blog/AddBlogCategory";
import EnquiryDetails from "../Views/Main Panel/EnquiryDetails";
import AddPropertyType from "../Views/Main Panel/Properties/PropertyType/AddPropertyType";
import ContactUS from "../Views/Main Panel/ContactUs";
import SubscriptionDetails from "../Views/Main Panel/SubscriptionDetails";
import PreviewBlog from "../Views/Main Panel/Blog/PreviewBLog";
const ShowProperties = lazy(() =>
  import("../Views/Main Panel/Properties/ShowProperties")
);
const Requests = lazy(() => import("../Views/Main Panel/Requests"));
const Shops = lazy(() => import("../Views/Main Panel/Reports/Shops"));
const Dashboard = lazy(() => import("../Views/Main Panel/Dashboard"));
const AmenitiesDetails = lazy(() => import("../Views/Main Panel/Amenities"));
const CategoryDetails = lazy(() =>
  import("../Views/Main Panel/CategoryDetails")
);
const VendorsDetails = lazy(() => import("../Views/Main Panel/VendorsDetails"));

const privateAdminRoute = () => {
  return [
    {
      element: <PrivateAuth />,
      children: [
        {
          path: "/dashboard",
          element: <Dashboard />,
        },
        {
          path: "/vendorsDetails",
          element: <VendorsDetails />,
        },
        {
          path: "/amenitiesDetails",
          element: <AmenitiesDetails />,
        },
        {
          path: "/categoryDetails",
          element: <CategoryDetails />,
        },
        {
          path: "/bannerDetails",
          element: <BannerDetails />,
        },
        {
          path: "/stateDetails",
          element: <StateCity />,
        },
        {
          path: "/showShops",
          element: <Shops />,
        },
        {
          path: "/userRequests",
          element: <Requests />,
        },
        {
          path: "/propertiesDetails",
          element: <Properties />,
        },
        {
          path: "/propertyTypeDetails",
          element: <AddPropertyType />,
        },
        {
          path: "/showDetails",
          element: <ShowProperties />,
        },
        {
          path: "/createProperty",
          element: <CreateProperty />,
        },
        {
          path: "/bodyTypeDetails",
          element: <BodyTypeDetails />,
        },
        {
          path: "/colorDetails",
          element: <ColourrDetails />,
        },
        {
          path: "/plotDetails",
          element: <PlotComponent />,
        },
        {
          path: "/showPlotDetails",
          element: <ShowPlot />,
        },
        {
          path: "/createPlot",
          element: <CreatePlot />,
        },
        {
          path: "/blog/addBlog",
          element: <AddBlog />,
        },
        {
          path: "/blog/blogCategory",
          element: <AddBlogCategory />,
        },
        {
          path: "/blog/blogData",
          element: <Blog />,
        },
        {
          path: "/blog/previewBlog",
          element: <PreviewBlog />,
        },
        {
          path: "/enquiryDetails",
          element: <EnquiryDetails />,
        },
        {
          path: "/contactDetails",
          element: <ContactUS />,
        },
        {
          path: "/subscriptionDetails",
          element: <SubscriptionDetails />,
        },
        {
          path: "*",
          element: <Dashboard />,
        },
      ],
    },
  ];
};

export default privateAdminRoute;
